import React from "react";
import AuthContext from '../store/AuthContext';
import { LiaToggleOffSolid, LiaToggleOnSolid } from "react-icons/lia";

const DimensionEnableSwitch: React.FC<{dimId: string}> = (props) => {
    const authCtx = React.useContext(AuthContext);
    const [enabled, setEnabled] = React.useState<boolean>(isDimensionEnabled(props.dimId));

    React.useEffect(() =>{
        setEnabled(isDimensionEnabled(props.dimId));
    }, [authCtx])

    function isDimensionEnabled(dimId: string) {
        return dimId in authCtx.account.dimensions &&
               authCtx.account.dimensions[dimId].enabled;
    }
    
    const handleToggle = () => {
        authCtx.enableDimension(props.dimId, !enabled);
        setEnabled(!enabled);
    };

return (
    <div onClick={handleToggle} className={enabled ? 'text-primary' : 'text-secondary'} style={{ display: 'flex', alignItems: 'center' }}>
        {enabled ? <LiaToggleOnSolid size={26} /> : <LiaToggleOffSolid size={26} />}
        <span style={{marginLeft: '10px'}}> {enabled ? 'Visible' : 'Invisible'} for you</span>
    </div>
);

};

export default DimensionEnableSwitch;
